// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    buttonText: {
        type: FIELD_TYPES.TEXT,
        label: "Button Text",
        translatable: true
    },
    case1Link: {
        type: FIELD_TYPES.TEXT,
        label: "Case 1 Link",
        translatable: true
    },
    case1Number: {
        type: FIELD_TYPES.TEXT,
        label: "Case 1 Number",
        translatable: true
    },
    case1Tag: {
        type: FIELD_TYPES.TEXT,
        label: "Case 1 Tag",
        translatable: true
    },
    case1Text: {
        type: FIELD_TYPES.TEXT,
        label: "Case 1 Text",
        translatable: true
    },
    case2Link: {
        type: FIELD_TYPES.TEXT,
        label: "Case 2 Link",
        translatable: true
    },
    case2Number: {
        type: FIELD_TYPES.TEXT,
        label: "Case 2 Number",
        translatable: true
    },
    case2Tag: {
        type: FIELD_TYPES.TEXT,
        label: "Case 2 Tag",
        translatable: true
    },
    case2Text: {
        type: FIELD_TYPES.TEXT,
        label: "Case 2 Text",
        translatable: true
    },
    case3Link: {
        type: FIELD_TYPES.TEXT,
        label: "Case 3 Link",
        translatable: true
    },
    case3Number: {
        type: FIELD_TYPES.TEXT,
        label: "Case 3 Number",
        translatable: true
    },
    case3Tag: {
        type: FIELD_TYPES.TEXT,
        label: "Case 3 Tag",
        translatable: true
    },
    case3Text: {
        type: FIELD_TYPES.TEXT,
        label: "Case 3 Text",
        translatable: true
    },
    case4Link: {
        type: FIELD_TYPES.TEXT,
        label: "Case 4 Link",
        translatable: true
    },
    case4Number: {
        type: FIELD_TYPES.TEXT,
        label: "Case 4 Number",
        translatable: true
    },
    case4Tag: {
        type: FIELD_TYPES.TEXT,
        label: "Case 4 Tag",
        translatable: true
    },
    case4Text: {
        type: FIELD_TYPES.TEXT,
        label: "Case 4 Text",
        translatable: true
    },
    case5Link: {
        type: FIELD_TYPES.TEXT,
        label: "Case 5 Link",
        translatable: true
    },
    case5Number: {
        type: FIELD_TYPES.TEXT,
        label: "Case 5 Number",
        translatable: true
    },
    case5Tag: {
        type: FIELD_TYPES.TEXT,
        label: "Case 5 Tag",
        translatable: true
    },
    case5Text: {
        type: FIELD_TYPES.TEXT,
        label: "Case 5 Text",
        translatable: true
    },
    case6Link: {
        type: FIELD_TYPES.TEXT,
        label: "Case 6 Link",
        translatable: true
    },
    case6Number: {
        type: FIELD_TYPES.TEXT,
        label: "Case 6 Number",
        translatable: true
    },
    case6Tag: {
        type: FIELD_TYPES.TEXT,
        label: "Case 6 Tag",
        translatable: true
    },
    case6Text: {
        type: FIELD_TYPES.TEXT,
        label: "Case 6 Text",
        translatable: true
    },
    case7Link: {
        type: FIELD_TYPES.TEXT,
        label: "Case 7 Link",
        translatable: true
    },
    case7Number: {
        type: FIELD_TYPES.TEXT,
        label: "Case 7 Number",
        translatable: true
    },
    case7Tag: {
        type: FIELD_TYPES.TEXT,
        label: "Case 7 Tag",
        translatable: true
    },
    case7Text: {
        type: FIELD_TYPES.TEXT,
        label: "Case 7 Text",
        translatable: true
    },
    case8Link: {
        type: FIELD_TYPES.TEXT,
        label: "Case 8 Link",
        translatable: true
    },
    case8Number: {
        type: FIELD_TYPES.TEXT,
        label: "Case 8 Number",
        translatable: true
    },
    case8Tag: {
        type: FIELD_TYPES.TEXT,
        label: "Case 8 Tag",
        translatable: true
    },
    case8Text: {
        type: FIELD_TYPES.TEXT,
        label: "Case 8 Text",
        translatable: true
    },
    case9Link: {
        type: FIELD_TYPES.TEXT,
        label: "Case 9 Link",
        translatable: true
    },
    case9Number: {
        type: FIELD_TYPES.TEXT,
        label: "Case 9 Number",
        translatable: true
    },
    case9Tag: {
        type: FIELD_TYPES.TEXT,
        label: "Case 9 Tag",
        translatable: true
    },
    case9Text: {
        type: FIELD_TYPES.TEXT,
        label: "Case 9 Text",
        translatable: true
    },
    title: {
        type: FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    case1Image: {
        type: FIELD_TYPES.NESTED,
        label: "Case 1 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case1Logo: {
        type: FIELD_TYPES.NESTED,
        label: "Case 1 Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case2Image: {
        type: FIELD_TYPES.NESTED,
        label: "Case 2 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case2Logo: {
        type: FIELD_TYPES.NESTED,
        label: "Case 2 Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case3Image: {
        type: FIELD_TYPES.NESTED,
        label: "Case 3 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case3Logo: {
        type: FIELD_TYPES.NESTED,
        label: "Case 3 Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case4Image: {
        type: FIELD_TYPES.NESTED,
        label: "Case 4 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case4Logo: {
        type: FIELD_TYPES.NESTED,
        label: "Case 4 Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case5Image: {
        type: FIELD_TYPES.NESTED,
        label: "Case 5 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case5Logo: {
        type: FIELD_TYPES.NESTED,
        label: "Case 5 Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case6Image: {
        type: FIELD_TYPES.NESTED,
        label: "Case 6 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case6Logo: {
        type: FIELD_TYPES.NESTED,
        label: "Case 6 Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case7Image: {
        type: FIELD_TYPES.NESTED,
        label: "Case 7 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case7Logo: {
        type: FIELD_TYPES.NESTED,
        label: "Case 7 Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case8Image: {
        type: FIELD_TYPES.NESTED,
        label: "Case 8 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case8Logo: {
        type: FIELD_TYPES.NESTED,
        label: "Case 8 Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case9Image: {
        type: FIELD_TYPES.NESTED,
        label: "Case 9 Image",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case9Logo: {
        type: FIELD_TYPES.NESTED,
        label: "Case 9 Logo",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case2UrlLink: {
        type: FIELD_TYPES.NESTED,
        label: "Case 2 URL Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    case3UrlLink: {
        type: FIELD_TYPES.NESTED,
        label: "Case 3 URL Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    case4UrlLink: {
        type: FIELD_TYPES.NESTED,
        label: "Case 4 URL Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    case5UrlLink: {
        type: FIELD_TYPES.NESTED,
        label: "Case 5 URL Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    case6UrlLink: {
        type: FIELD_TYPES.NESTED,
        label: "Case 6 URL Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    case7UrlLink: {
        type: FIELD_TYPES.NESTED,
        label: "Case 7 URL Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    case8UrlLink: {
        type: FIELD_TYPES.NESTED,
        label: "Case 8 URL Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    case9UrlLink: {
        type: FIELD_TYPES.NESTED,
        label: "Case 9 URL Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    }
};
